import ReportSync from './SyncReport';

export default ReportSync;
